import React, { useState } from "react";
import RoleBasedComponent from "../../components/RoleBasedComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setTourEdit } from "../../reducer/tourEditReducer";
import { setPackageData } from "../../reducer/tourReducer";
import { Paths } from "../../router/Paths";

export default function ManageImagesGallerySection({ packageData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleEdit = () => {
    dispatch(setTourEdit(packageData._id));
    navigate(Paths.tourManagementPackagePhotoUpload, {
      state: { packageData },
    });
  };

  const handleRemoveImage = (index: number) => {
    const updatedImages = (packageData?.gallery || []).filter(
      (_: any, idx: number) => idx !== index
    );

    // Remove the galleryKey at the same index
    let updatedGalleryKeys = packageData?.galleryKeys;
    if (Array.isArray(packageData?.galleryKeys)) {
      updatedGalleryKeys = packageData?.galleryKeys.filter(
        (_: any, idx: number) => idx !== index
      );
    }

    // Mark as edited
    dispatch(setTourEdit(packageData._id));

    dispatch(
      setPackageData({
        ...packageData,
        gallery: updatedImages,
        galleryKeys: updatedGalleryKeys, // always set, even if undefined
      })
    );
  };

  return (
    <div className="mb-2.5 sm:mb-12">
      <div className="flex justify-end mb-2">
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>

      <section className="flex overflow-x-auto space-x-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
        {packageData?.gallery?.length > 0 ? (
          packageData.gallery.map((image: any, index: number) => (
            <div
              key={index}
              className="flex-shrink-0 w-full max-w-[525px] h-[180px] sm:h-[350px] bg-gray-200 rounded-lg overflow-hidden relative group"
            >
              {/* Remove button, same style as upload page */}
              <button
                className="bg-white w-8 h-8 rounded-full hidden group-hover:flex items-center justify-center absolute right-2 top-2 shadow-md cursor-pointer z-10"
                onClick={() => handleRemoveImage(index)}
                disabled={loading}
                title="Remove image"
                type="button"
              >
                <img
                  src="/IconClose1.svg"
                  alt="Remove"
                  className="w-4 object-contain"
                />
              </button>
              <img
                src={image}
                alt={`package ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))
        ) : (
          <div className="flex-shrink-0 w-full h-[180px] sm:h-[350px] bg-gray-200 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">No images available</p>
          </div>
        )}
      </section>
    </div>
  );
}
